export default "__VITE_ASSET__CefgDZD6__"